import React from 'react';

export const PageHero = ({ eyebrow, title, subtitle }) => (
  <section className="relative bg-forest-900 overflow-hidden" data-testid="page-hero">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(122,140,113,0.25),transparent_55%)]" aria-hidden="true"></div>
    <div className="relative max-w-5xl mx-auto px-6 md:px-10 py-20 md:py-28 text-center">
      {eyebrow && <p className="text-sm font-semibold uppercase tracking-[0.2em] text-gold-500 mb-4">{eyebrow}</p>}
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cream-100 tracking-tight leading-tight">{title}</h1>
      {subtitle && <p className="text-lg md:text-xl text-sage-100/85 mt-6 max-w-2xl mx-auto leading-relaxed">{subtitle}</p>}
    </div>
  </section>
);

export default PageHero;
